module.exports = __webpack_public_path__ + "static/portfolio_gallery_31-5b18780f175b34931d6b5b8338bf4d40.jpg";